import { Exercise } from "@domain/exercise/exercise";
import { useExerciseFormatter } from "@ui/components/exercise/hooks/use-exercise-formatter";
import styled from "@emotion/styled";
import { BodyPartIcon } from "@ui/components/exercise/body-part-icon";
import { row, stack } from "@ui/style";
import { colors } from "@ui/style/colors";
import React from "react";

interface ExerciseCardHeaderProps {
	exercise: Exercise;
	onClick?: () => void;
}

export const ExerciseCardHeader: React.FC<ExerciseCardHeaderProps> = ({ exercise, onClick }) => {
	const { formatExerciseCategory } = useExerciseFormatter();

	return (
		<Header onClick={onClick}>
			<ExerciseCategory className="p-size-s-semi-bold">{formatExerciseCategory(exercise.category)}</ExerciseCategory>
			<Row>
				<ExerciseTitle className="p-size-s-rubik-medium">{exercise.title}</ExerciseTitle>
				<BodyPartIcon
					bodyPart={exercise.primaryBodyPart}
					additionalBodyPartsCount={exercise.secondaryBodyParts.length}
					width={24}
					height={24}
				/>
			</Row>
		</Header>
	);
};

const Header = styled.div`
	${stack(0, "spacebetween", "stretch")};
	padding: 0 16px;
	cursor: pointer;
`;

const Row = styled.div`
	${row(0, "spacebetween", "center")};
`;
const ExerciseCategory = styled.p`
	color: ${colors.grey80};
`;

const ExerciseTitle = styled.div`
	flex: 1;
`;
